module.exports = __webpack_public_path__ + "img/detail-mode3-3.f8a7f345.png";